import {uiMsg} from '../utils/Languages';
import React, {Component} from 'react';
import {observer} from 'mobx-react';
import ServerAPI from '../ServerAPI';
import Promise from 'bluebird';

import {List, ListItem} from 'material-ui/List';

import Avatar from 'material-ui/Avatar';
import Business from 'material-ui/svg-icons/communication/business';
import Machine from 'material-ui/svg-icons/action/settings-remote';

import {green500, blue500, orange500} from 'material-ui/styles/colors';

import AppModel from '../DataModel/AppModel';
import AppModelUtils from '../DataModel/AppModelUtils';
import Subheader from 'material-ui/Subheader';

// Lists customers and expands users from customer when clicked, allowing
// user selection to be made.
export default @observer
class CustomerMachineList extends Component {

  // When the user clicks customer, we will fetch the set of machines for
  // that company and expand the machine list as a sublist under the customer
  loadMachinesFor(customer) {
    return function() {
      customer.loadingMachines = true;
      AppModelUtils.fetch_machinelist_for(customer)
      .finally(function(){
        customer.loadingMachines = false;
      });
    }
  }

  // When a machine has been clicked - we call the provided
  // action function with the customer/machine id-combo:.
  machineSelected(machine) {
    var self = this;
    return function() {
      self.props.onSelect(machine);
    }
  }

  machineLoadingItem() {
    var element = (
      <ListItem
          key={"dummykey"}
          value={"No value"}
          leftAvatar={ <Avatar icon={<Machine />}
                               backgroundColor={blue500} />}
          primaryText={uiMsg('CML_LOADING_MACHINES',"Loading machines ..")}
      />
    )
    return [element];
  }

  machineItem(machine) {
    return (
      <ListItem
        key={machine.id}
        onTouchTap={
          this.machineSelected(machine).bind(this)
        }
        leftAvatar={ <Avatar icon={<Machine />}
                             backgroundColor={blue500} />}
        primaryText={(<div>{machine.name}, (<b>{machine.id}</b>)</div>)}
        />
    )
  }
  filterMachines(searchTerm){
    let st = searchTerm.toLowerCase();
    return function(machine){
      return machine.name ? machine.name.toLowerCase().includes(st) : false || machine.id.toLowerCase().includes(st);
    }
  }

  render() {
    var self = this;
    var customers = this.props.customers;
    var searchTerm = this.props.searchTerm;
    return (
      <List>
        <Subheader>{uiMsg('CML_SELECT_MACHINE',"Select customer and machine")} :</Subheader> {
          customers.map(function(customer) { return (
            <ListItem
                key = {customer.id}
                value={customer.id}
                leftAvatar={ <Avatar icon={<Business />}
                                    backgroundColor={orange500} />}
                primaryText={customer.name}
                initiallyOpen={true}
                nestedItems={
                  customer.loadingMachines ? self.machineLoadingItem() :
                  customer.machines.filter(self.filterMachines(searchTerm)).map(self.machineItem.bind(self))}
                onTouchTap={self.loadMachinesFor(customer).bind(self)}
            />
        )})
      } </List>
    );
  }
};



/** WEBPACK FOOTER **
 ** ./src/components/CustomerMachineList.jsx
 **/